import { mostraAlertaError, mostraAlertaOk, mostraAlertaPregunta } from "../../../../componentes/alerts/sweetAlert";
import { useEffect, useState } from "react"
import { InventariosTiposEliminar, InventariosTiposListar } from "../../../../configuracion/apiUrls"; 
import { AxiosPrivado } from "../../../../componentes/axios/Axios";

const EliminarInventarioTipo = ({ datos, token, setListaInventariosTipos, ActualizarLista }) => {
    const [eliminar, setEliminar] = useState(false);

    useEffect(() => {
        if (eliminar)
            eliminarInventarioTipo();
    }, [eliminar])

    const eliminarInventarioTipoPregunta = async (f) => {
        mostraAlertaPregunta(setEliminar, "¿Deseas eliminar el tipo de inventario " + datos.nombre + " de forma permanente?", "warning");
    }

    const eliminarInventarioTipo = async () => {
        if (!datos.id)
            mostraAlertaError("Seleccione un tipo de inventario");
        else {
            try {
                AxiosPrivado.defaults.headers.common['Authorization'] = `Bearer ${token}`;
                AxiosPrivado.delete(InventariosTiposEliminar + datos.id)
                    .then((respuesta) => {
                        ActualizarLista(InventariosTiposListar, setListaInventariosTipos);
                        mostraAlertaOk("Registro eliminado correctamente");
                    }).catch((er) => {
                        console.log(er);
                        var msjError = "";
                        switch (er.response.status) {
                            case 400:
                                if (er.response.data && Array.isArray(er.response.data)) {
                                    er.response.data.map(f => {
                                        msjError += f.msg + '. '
                                    })
                                } else if (er.response.data && er.response.data.error) {
                                    msjError = er.response.data.error;
                                }
                                break;
                            case 404:
                                msjError = "Ruta no encontrada en la api"; // Agregado para 404
                                break;
                            case 500:
                                msjError = er.response.data.error;
                                break;
                            default:
                                msjError = "Ocurrió un error desconocido.";
                                break;
                        }
                        mostraAlertaError(msjError, "error");
                    })
            } catch (error) {
                mostraAlertaError("Error en la petición")
            }
        }
        setEliminar(false);
    }

    return (
        <button type="button" className="btn btn-outline-danger" onClick={eliminarInventarioTipoPregunta}>
            <i className="fas fa-trash" />
        </button>
    );
}
export default EliminarInventarioTipo;